<template>
  <div id="app">
    <div class="header">
      <div class="drop-down" @click="showNav" v-show="isShowNav">
        <img src="./assets/images/dropdown.png" alt />
      </div>
      <div class="backroute" @click="backRoute" v-show="!isHome">
        <img src="./assets/images/backroute.png" alt />
      </div>
      <div class="name">
        <img src="./assets/images/logo.png" alt />
        <div class="title-name">客服中心</div>
      </div>
      <Login class="ear-icon"></Login>
    </div>
    <game-nav v-model="isShowHomeNav" v-if="isShowHomeNav"></game-nav>
    <hot-line v-model="isShowLine" v-if="isShowLine"></hot-line>
    <router-view />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import gameNav from '@/components/gameNav';
import hotLine from '@/components/hotLine';
import Login from './views/login';
export default {
  name: "App",
  components: {
    gameNav,
    hotLine,
    Login
  },
  data() {
    return {
      isShowHomeNav: false,
      isShowLine: false,
      // home: this.$route.path === '/' ? true : false,
    }
  },
  computed: {
    ...mapState(['isShowNav', 'isHome'])
  },
  methods: {
    showNav() {
      this.isShowHomeNav = !this.isShowHomeNav;
    },
    showLine() {
      this.isShowLine = !this.isShowLine;
    },
    backRoute() {
      this.$router.go(-1);
    }
  }
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-tap-highlight-color: transparent;
  color: #333;
}
</style>
<style lang="scss" scoped>
#app {
  .header {
    display: flex;
    align-items: center;
    height: 100px;
    background: linear-gradient(#e1303a, #f04133);
    // justify-content: space-between;
    padding: 0 28px;
    position: relative;
    .drop-down {
      width: 40px;
      height: 40px;
      margin-right: 32px;
    }
    .backroute {
      width: 48px;
      height: 48px;
      // margin-left: 32px;
    }
    .name {
      height: 54px;
      width: 350px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      img {
        width: 210px;
      }
      .title-name {
        font-size: 30px;
        color: white;
      }
    }
    .ear-icon {
      // width: 66px;
      // height: 44px;
      font-weight: bold;
      color: white;
      font-size: 32px;
      margin-left: auto;
    }
    
  }
}
</style>